import React, { FormEvent, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@eika/button';
import { Link } from '@eika/link';

import { useConfig } from '../../../../defaultConfig';
import useTranslation, { format } from '../../../../hooks/useTranslation';
import { useSigningContext } from '../../../../signingContext/signingContext';
import AgreementCheckboxes from '../../components/AgreementCheckboxes';
import { useAvtaleGiroMoveContext } from '../../context/AvtaleGiroMoveContext';
import ROUTES from '../../routes';

const ChooseAgreements = () => {
    const translated = useTranslation();
    const { avtalegiroLink } = useConfig();
    const navigate = useNavigate();

    const { dynamicLinkId } = useSigningContext();

    const {
        selectedAgreements: [selectedAgreements],
        error: [, setErrorByKey],
    } = useAvtaleGiroMoveContext();

    const confirm = useCallback(
        (event: FormEvent) => {
            event.preventDefault();
            setErrorByKey('selectedAgreements', undefined);
            if (selectedAgreements.length < 1) {
                setErrorByKey('selectedAgreements', translated.moveAvtaleGiro.errors.noAvtaleGirosSelected);
                return;
            }
            navigate(ROUTES.summary);
        },
        [selectedAgreements, translated.moveAvtaleGiro, setErrorByKey, navigate],
    );

    useEffect(() => {
        if (!dynamicLinkId) navigate('/');
    }, [dynamicLinkId, navigate]);

    return (
        <form className="move-avtalegiro-form" onSubmit={confirm}>
            <AgreementCheckboxes />
            <section className="move-avtalegiro__action-button-wrapper">
                <Button type="submit">
                    {format(translated.moveAvtaleGiro.moveAvtaleGiro, selectedAgreements.length)}
                </Button>
                {avtalegiroLink && <Link href={avtalegiroLink.url}>{translated.cancel}</Link>}
            </section>
        </form>
    );
};

export default ChooseAgreements;
